// The boards in his town.
//
// EVENT posters are earned by standing and announce something that is
// actually going to happen: they feed the calendar path (he plans around
// it, and regrets missing it). The other boards (AD_SLOTS, the name is
// from when they were sold) carry nothing anybody paid for. Sam, 3 Oct:
// advertising came out with the rest of the selling, so those boards are
// his now, and the billboards run his own program (lib/ads/deadScreens.js).

// Deliberately scarce, and deliberately NOT wherever there is wall space.
// A slot is a place he passes, so the inventory is bounded by his life
// rather than by the map, and it sells out like the dishes do.
//
// `place` is the verdict key his visit count is filed under. Keep them in
// step with the sim's place vocabulary or a slot prices itself at the
// floor, which is the safe direction to be wrong in.
//
// `position` is read off adPosters.glb and is the truth about where the
// board hangs, not a request. The renderer does not use it (it draws the
// GLB and finds meshes by node name) but the SIM does: Boards.js measures
// from these to decide whether he is close enough to have read the thing.
// Every one of them was wrong until 2026-08-19, because they were written
// as guesses before the models existed. Re-export the GLB, re-read them.
export const AD_SLOTS = [
  {
    // Ids are the node names in adPosters.glb. Keeping them identical is
    // what lets the renderer find a slot's mesh without a second mapping
    // table that somebody has to remember to update.
    id: 'billboard_salon',
    format: 'billboard',
    place: 'salon',
    label: 'the board by the salon',
    detail: 'he goes to get his feathers done, and stands about outside it',
    position: [55.40, -1.74, -9.02],
    rotY: 0,
  },
  {
    id: 'billboard_museum',
    format: 'billboard',
    place: 'museum',
    label: 'the board on the museum approach',
    detail: 'he queues to get in, and he reads whatever is in front of him while he waits',
    // Out on the approach, NOT on the museum wall: that wall is where the
    // museum's own event poster goes, and the two must not share a face.
    position: [-26.66, 0, -55.27],
    rotY: 125,
  },
  {
    id: 'poster_laundrette',
    format: 'poster',
    place: 'laundrette',
    label: 'the laundrette window',
    detail: 'he watches the machines go round for a long time',
    position: [48.69, 1.56, -26.00],
    rotY: -90,
  },
  {
    id: 'poster_coffee',
    format: 'poster',
    place: 'caffeine',
    label: 'the wall by the coffee shop',
    detail: 'read standing up, waiting, most mornings',
    position: [37.03, 2.60, 14.45],
    rotY: 0,
  },
  {
    id: 'poster_phone',
    format: 'poster',
    place: 'phone',
    label: 'inside the phone box',
    detail: 'small, close, and read while he waits for nothing',
    position: [-26.81, 3.18, 51.86],
    rotY: -90,
  },
  {
    id: 'poster_pond',
    format: 'poster',
    place: 'pond',
    label: 'the post by the pond',
    detail: 'quiet corner. cheap, and he is calm when he reads it',
    position: [-93.74, 2.03, 38.93],
    rotY: 90,
  },
]

// Where the EVENT posters hang, which is a different list on purpose.
//
// These are not for sale and never will be: they are what standing earns.
//
// They do NOT have to sit on their venue. That used to be a hard
// requirement, because the sim only handed him a poster when he was at the
// place the event happened, so a sheet hung anywhere else was a sheet he
// could never read. The rave's is 22 metres from the rave and the cinema's
// is 14 from the cinema, which is where they look right and where they
// were always going to end up. Boards.js measures from the POI in front of
// each one instead, so he reads them by walking past.
//
// Positions are read off eventPosters.glb, same rule as AD_SLOTS above.
export const EVENT_SLOTS = [
  { id: 'museum_bill', format: 'billboard', place: 'museum', position: [-14.74, 2.31, -56.68], rotY: 0, hosts: 'exhibition' },
  { id: 'cinema_bill', format: 'billboard', place: 'cinema', position: [10.30, 7.91, 56.23], rotY: 90, hosts: 'film' },
  { id: 'rave_sheet', format: 'poster', place: 'rave', position: [-28.04, 2.04, -2.04], rotY: -40, hosts: 'gig' },
  { id: 'bar_sheet', format: 'poster', place: 'bar', position: [78.74, 1.85, -0.17], rotY: 0, hosts: 'gig, special' },
]
